import type { SpreadReadingProfile } from "../types";

export const relationshipsReadingProfile: SpreadReadingProfile = {
  spreadId: "spread_relationships",
  sections: [
    {
      id: "mainMeaning",
      title: "Основной смысл",
      source: { type: "keywords" },
    },
    {
      id: "relationships",
      title: "В отношениях",
      source: {
        type: "upright",
        context: "relationships",
      },
    },
    {
      id: "psychology",
      title: "Психологический аспект",
      source: { type: "psychology" },
    },
  ],
};

